module.exports = "//static.hsappstatic.net/salesImages/static-1.403/product-features/colleague-connections.png"